import {
    BonusModel,
    CmpsScoreSectionData,
    CmpsScoreSectionMenuData,
    CmpsScoreSectionTrendData,
    RankViewModel,
} from '@cmps/ng-kit';

import { HeaderRowData } from '../card--my-coaching-card/models/header-row-data.model';

import { ScCategory } from './models/sc-category.model';
export interface ScorecardData {
    headerRowData?: HeaderRowData;
    scorecardSubHeader?: ScorecardSubHeader;
    adjustScoreData?: CmpsScoreSectionData;
    originalScoreData?: CmpsScoreSectionData;
    trendData?: CmpsScoreSectionTrendData;
    dropdownMenuData?: CmpsScoreSectionMenuData;
    rankData?: RankBonusModel;
    bonusData?: BonusModel;
    scCategory?: ScCategory;
}

export interface ScorecardSubHeader {
    supergroupLabel?: string;
    scorecardId: string;
    supergroupValue?: string;
    scorecardValue: string;
    isDisabled?: boolean;
}

export enum MenuItems {
    'LAUNCH_SCORECARD' = 1,
    'TREND',
    'ADD_RANK',
    'ADD_BONUS',
}
export interface RankBonusModel {
    titleLabel?: string;
    data: RankViewModel[];
}
export interface PillarData {
    pillarId: number;
    pillarValue: number;
    displayOrder: number;
}
